import ajax from "./ajax";

/**
 * 登录
 * @param {*} userInfo
 * @returns
 */
export const reqLogin = userInfo => ajax(`/oauth2/login`, userInfo, "POST");

/**
 * 刷新token
 */
export const reqRefreshToken = data => ajax(`/oauth2/login`, data, "POST");

/**
 * 获取角色
 * @returns
 */
export const reqRoles = data =>
  ajax(`/api/organize/settings/roles`, {
    ...data,
    pageSize: 1000,
    orderby: "_id desc", // 添加排序参数，按 _id 字段降序排列
  });
/**
 * 获取角色详情
 * @param {*} role_id
 * @returns
 */
export const reqRolesDetail = id => ajax(`/api/organize/settings/roles/${id}`);

/**
 * 添加角色
 * @param {*} data
 * @returns
 */
export const reqAddRole = data =>
  ajax(`/api/organize/settings/roles`, data, "POST");

/**
 * 添加角色
 * @param {*} data
 * @returns
 */
export const reqUpdataRole = (roles_id, data) =>
  ajax(`/api/organize/settings/roles/${roles_id}`, data, "PUT");

/**
 * 更新角色
 * @param {*} role
 * @returns
 */
export const reqUpdateRole = (role_id, data) =>
  ajax(`/api/organize/settings/roles/${role_id}`, data, "PUT");

export const reqDeleteRole = role_id =>
  ajax(`/api/organize/settings/roles/${role_id}`, {}, "DELETE");

/**
 * 获取用户列表
 * @param {*} verbose
 * @returns
 */
export const reqUsers = data =>
  ajax(`/api/organize/settings/users?orderby=_id desc,`, data);

/**
 * 获取用户详情
 * @param {*} email
 * @param {*} verbose
 * @returns
 */

export const reqUserDetail = (email, verbose) =>
  ajax(`/api/organize/settings/users/${email}`, {
    verbose,
  });

/**
 * 修改用户权限
 * @param {*} email
 * @param {*} roles
 * @returns
 */
export const reqUpdateUser = (email, roles) =>
  ajax(`/api/organize/settings/users/${email}`, roles, "PUT");

/**
 * 查询客户端
 * @returns
 */
export const reqGetClients = data =>
  ajax(`/api/organize/settings/clients`, data);

/**
 * 查询客户端详情
 * @returns
 */
export const reqGetDetailClient = client_id =>
  ajax(`/api/organize/settings/clients/${client_id}?verbose=100`);

/**
 * 新增客户端
 * @returns
 */
export const reqAddClient = data =>
  ajax(`/api/organize/settings/clients`, data, "POST");

/**
 * 删除客户端
 * @returns
 */
export const reqDelClient = id =>
  ajax(`/api/organize/settings/clients/${id}`, {}, "DELETE");

/**
 * 修改客户端
 * @returns
 */
export const reqUpdateClient = (client_id, data) =>
  ajax(`/api/organize/settings/clients/${client_id}`, data, "PATCH");

/**
 * 重置client_secret
 * @returns
 */
export const reqResetSecret = data =>
  ajax(`/api/organize/settings/client/actions/reset-secret`, data, "POST");

/**
 * 获取产品one列表
 * @param {*} verbose
 * @returns
 */
export const Getpro = data => ajax(`/api/plm/product/category-groups`, data);

// 新增大产品
export const addpro = data =>
  ajax(`/api/plm/product/category-group`, data, "POST");
// 修改大产品
export const putpro = data =>
  ajax(`/api/plm/product/category-group/${data.id}`, data, "PUT");
// 查询id系列

export const idpro = data =>
  ajax(`/api/plm/product/category-group/${data}/detail`, "GET");

/**
 * 获取产品分类one列表
 * @param {*} verbose
 * @returns
 */
export const Getcategories = data => ajax(`/api/plm/product/categories`, data);
// 修改系列
export const putcategories = data =>
  ajax(`/api/plm/product/categories/${data.id}`, data, "PUT");
export const IDcategories = data =>
  ajax(`/api/plm/product/categories/${data.id}/detail`, "GET");
export const postcategories = data =>
  ajax(`/api/plm/product/categories`, data, "POST");

/**
 * 获取产品系列one列表
 * @param {*} verbose
 * @returns
 */
export const Getseries = data => ajax(`/api/plm/product/series`, data);
// 新增系列
export const addseries = data => ajax(`/api/plm/product/series`, data, "POST");
// 修改系列
export const putseries = data =>
  ajax(`/api/plm/product/series/${data.id}`, data, "PUT");

// 查询id系列
export const idseries = data =>
  ajax(`/api/plm/product/series/${data.id}/detail`, "GET");

// 查询系列
export const nameSeries = data => {
  const { name, pageNumber, pageSize, verbose } = data;
  const queryParams = `name=${name}&pageNumber=${pageNumber}&pageSize=${pageSize}&verbose=${verbose}`;
  return ajax(`/api/plm/product/series-list?${queryParams}`, "GET");
};
